import IconText from "../components/IconText";
import { IoSearch } from "react-icons/io5";
import { IoIosArrowForward } from "react-icons/io";
import { BsPhone } from "react-icons/bs";

import logo from "../assets/images/logo.png";
import Divider from "../components/Divider";
import { forwardRef } from "react";

const MobileMenu = forwardRef((props, ref) => {
  return (
    <>
      <div
        className={`overlay absolute  h-full w-full bg-black top-0 left-0 z-10 transition-all duration-700 ${
          props.menubarOpen ? "visible opacity-60" : "invisible opacity-0"
        }`}
        onClick={props.handleClick}
      ></div>
      <section
        className={`max-w-screen-sm w-full top-0 left-0 z-20 p-1 absolute bg-white h-full transition-all duration-300 ${
          props.menubarOpen ? "visible " : "invisible -left-full"
        }`}
        ref={ref}
      >
        <div className="content p-1">
          <div className="header flex flex-row items-center xs:py-4 xl:py-0 h-20">
          </div>
          <Divider />
          <div className="nav text-[15px] overflow-y-auto h-[calc(100vh_-_88px)]">
            <nav className="">
              {Array(4)
                .fill("")
                .map((item, index) => {
                  return (
                    <div className="nav-item px-2 py-3 hover:text-gray-700" key={index}>
                      <a
                        href=""
                        className="nav-item flex items-center justify-between"
                      >
                        <IconText
                          iconInfo={{
                            Icon: IoSearch,
                            classes: "h-5 w-5 text-gray-600 font-normal",
                          }}
                          textInfo={{
                            text: "Dietitian - Monthly subscriptions",
                          }}
                          iconFirst
                          gap={"mx-2"}
                        />
                        <IconText
                          iconInfo={{
                            Icon: IoIosArrowForward,
                            classes: "h-5 w-5",
                          }}
                        />
                      </a>
                    </div>
                  );
                })}
              <Divider />
              <div className="nav-item download-app mx-3 my-2 bg-[#e46552] border-2 border-[#e46552] rounded-md text-white p-2 text-[13px] hover:bg-white hover:text-[#e46552] transition-all duration-200">
                <a href="" className="nav-item flex items-center">
                  <div className="icon">
                    <IconText
                      iconInfo={{
                        Icon: BsPhone,
                        classes: "h-10 w-10 mr-2",
                      }}
                    />
                  </div>
                  <div className="text">
                    <IconText
                      textInfo={{
                        text: "Download The App",
                        classes: "uppercase",
                      }}
                      iconFirst
                    />
                    <IconText
                      textInfo={{
                        text: "Do even more with Gepzo App!",
                        classes: "text-[11px]",
                      }}
                      iconFirst
                    />
                  </div>
                </a>
              </div>
              <Divider />
              <div className="nav-item px-3 py-2 text-gray-500 hover:text-gray-500/75">
                <a
                  href=""
                  className="nav-item flex items-center justify-between"
                >
                  <IconText textInfo={{ text: "Gepzo for pros" }} />
                  <IconText
                    iconInfo={{
                      Icon: IoIosArrowForward,
                      classes: "h-5 w-5",
                    }}
                  />
                </a>
              </div>
              <div className="nav-item px-3 py-2 hover:text-gray-700">
                <a
                  href=""
                  className="nav-item flex items-center justify-between"
                >
                  <IconText textInfo={{ text: "Gepzo for pros" }} />
                  <IconText
                    iconInfo={{
                      Icon: IoIosArrowForward,
                      classes: "h-5 w-5",
                    }}
                  />
                </a>
              </div>
            </nav>
          </div>
        </div>
      </section>
    </>
  );
});

export default MobileMenu;
